import { useFormatAmount, useIntl } from '@capsicum/common';
import { PageSidePanelItem, useRouter } from '@capsicum/common-web';
import { useTrendingFanTokens } from '@capsicum/features/wallet/shared';
import { useCallback } from 'react';
import styled from 'styled-components';

import { useBuySellButtonsForMarketplace } from '../../hooks';
import { TrendingFanTokenCard } from '../../ui';

export const TrendingFanTokenSidePanel = () => {
	const { availableMarketsData, defaultCurrency, isMarketplaceEnabled } = useTrendingFanTokens();
	const {
		handleBuyClick,
		isBuyLoading,
		isFanTokenDirectPurchaseEnabled,
		isMarketplaceFanTokenBuyEnabled,
		tradeTokenId
	} = useBuySellButtonsForMarketplace();

	const { $t } = useIntl();
	const { push } = useRouter();

	const { formatAmount } = useFormatAmount();

	const goToPartnerPage = useCallback((partnerId?: string) => push(`/partner/${partnerId}`), [push]);

	if (!isMarketplaceEnabled || !availableMarketsData?.length) {
		return;
	}

	return (
		<PageSidePanelItem
			title={availableMarketsData?.length ? $t('wallet.sidePage.trendingFanToken.title') : undefined}
		>
			<S.Container>
				{availableMarketsData?.map((marketPerPartner, index) => {
					// This is to prevent rendering whole list when buy or sell is clicked and only re-render the clicked market
					const isTokenSelectedForTrading = tradeTokenId === marketPerPartner.market?.baseCurrency?.id;

					return (
						<TrendingFanTokenCard
							amount={formatAmount(marketPerPartner.market?.ticker?.lastPrice)}
							cardPosition={index}
							currency={defaultCurrency}
							isBuyEnabled={
								isFanTokenDirectPurchaseEnabled &&
								isMarketplaceFanTokenBuyEnabled &&
								!!marketPerPartner.market?.isBuyAllowed
							}
							isBuyLoading={isTokenSelectedForTrading && isBuyLoading}
							key={index}
							listLength={availableMarketsData.length}
							market={marketPerPartner.market}
							partnerId={marketPerPartner.id}
							partnerLogo={marketPerPartner.images?.partnerLogo?.url}
							partnerShortName={marketPerPartner.shortName}
							testID={`wallet-sidepanel-trending-fan-token-${marketPerPartner.id}`}
							onClickBuy={handleBuyClick}
							onClickLogo={goToPartnerPage}
						/>
					);
				})}
			</S.Container>
		</PageSidePanelItem>
	);
};

namespace S {
	export const Container = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxxxsmall};
	`;
	export const Title = styled.div`
		${({ theme }) => theme.fonts.headings.title5}
		text-align:left;
		width: 100%;
		margin-bottom: ${({ theme }) => theme.spacings.xsmall};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
}
